module.exports = __webpack_public_path__ + "fonts/CeraPro-Bold.9ffb919c.woff2";